var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentTerminal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 532.58 286.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2{fill:#fff;}.cls-3{fill:#f4bb3b;}.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10{stroke:#000;stroke-miterlimit:10;}.cls-3,.cls-4,.cls-6,.cls-7,.cls-9,.cls-10{stroke-width:.5px;}.cls-11{fill:url(#linear-gradient-17);}.cls-4{fill:url(#linear-gradient-12);}.cls-12{fill:url(#linear-gradient-15);}.cls-13{fill:url(#linear-gradient-18);}.cls-14{fill:url(#linear-gradient-28);}.cls-15{fill:url(#linear-gradient-14);}.cls-16{fill:url(#linear-gradient-20);}.cls-17{fill:url(#linear-gradient-6);}.cls-5{stroke-width:1.06px;}.cls-5,.cls-9{fill:none;}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-16);}.cls-6{fill:url(#linear-gradient-24);}.cls-20{fill:#7d7d7d;}.cls-7{fill:url(#linear-gradient-10);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-25);}.cls-23{fill:url(#linear-gradient-5);}.cls-8{fill:#00ec00;}.cls-24{fill:url(#linear-gradient-7);}.cls-25{fill:url(#linear-gradient-9);}.cls-26{fill:url(#linear-gradient-22);}.cls-27{fill:url(#linear-gradient-3);}.cls-28{fill:url(#linear-gradient);}.cls-29{fill:url(#linear-gradient-27);}.cls-30{fill:url(#linear-gradient-29);}.cls-31{fill:url(#linear-gradient-30);}.cls-32{fill:url(#linear-gradient-23);}.cls-33{fill:url(#linear-gradient-19);}.cls-34{fill:#231f20;}.cls-35{fill:url(#linear-gradient-4);}.cls-36{fill:url(#linear-gradient-8);}.cls-10{fill:#878391;}.cls-37{fill:url(#linear-gradient-13);}.cls-38{fill:url(#linear-gradient-26);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 186.54,
    y1: 106.67,
    x2: 313.34,
    y2: 106.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 189.57,
    y1: 103.12,
    x2: 310.28,
    y2: 103.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 249.92,
    y1: 157.1,
    x2: 249.92,
    y2: 49.16,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e4e4e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 249.94,
    y1: 182.19,
    x2: 249.94,
    y2: 173.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#292929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 315.23,
    y1: 106.67,
    x2: 322.6,
    y2: 106.67,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#363636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 221.32,
    y1: 43.92,
    x2: 221.32,
    y2: 33.53,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#26ff15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00d023",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 239.82,
    x2: 239.82,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 258.32,
    x2: 258.32,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 276.82,
    x2: 276.82,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 670.36,
    y1: 103.42,
    x2: 610.45,
    y2: -0.35,
    gradientTransform: "translate(-433.66 54.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#e8f2fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#c0dbf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a0c9ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#89bceb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#7bb4e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77b2e9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 491.01,
    y1: 103.31,
    x2: 498.38,
    y2: 103.31,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 177.88,
    y1: 44.99,
    x2: 119,
    y2: -56.98,
    gradientTransform: "translate(656.94 91.9) rotate(-180)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 358.31,
    y1: 103.31,
    x2: 485.12,
    y2: 103.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 361.34,
    y1: 99.76,
    x2: 482.06,
    y2: 99.76,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 421.7,
    y1: 153.74,
    x2: 421.7,
    y2: 45.8,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 421.71,
    y1: 178.83,
    x2: 421.71,
    y2: 169.99,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 393.1,
    y1: 40.56,
    x2: 393.1,
    y2: 30.17,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2483c5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 411.6,
    x2: 411.6,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 430.1,
    x2: 430.1,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 448.6,
    x2: 448.6,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 132.69,
    y1: 108.23,
    x2: 140.07,
    y2: 108.23,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0,
    y1: 108.23,
    x2: 126.8,
    y2: 108.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 63.4,
    y1: 183.75,
    x2: 63.4,
    y2: 174.9,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 849.56,
    y1: 148.76,
    x2: 789.65,
    y2: 44.99,
    gradientTransform: "translate(-753.48 103.66)",
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 3.03,
    y1: 104.68,
    x2: 123.74,
    y2: 104.68,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 63.39,
    y1: 158.66,
    x2: 63.39,
    y2: 50.72,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 34.79,
    y1: 45.48,
    x2: 34.79,
    y2: 35.09,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 53.29,
    y1: 45.48,
    x2: 53.29,
    y2: 35.09,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 71.79,
    y1: 45.48,
    x2: 71.79,
    y2: 35.09,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 90.29,
    y1: 45.48,
    x2: 90.29,
    y2: 35.09,
    xlinkHref: "#linear-gradient-17"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 281.3,
    y: 31.34,
    width: 38.24,
    height: 150.65,
    rx: 5.71,
    ry: 5.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 186.54,
    y: 31.08,
    width: 126.8,
    height: 151.17,
    rx: 24.68,
    ry: 24.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 189.57,
    y: 34.2,
    width: 120.71,
    height: 137.84,
    rx: 20.65,
    ry: 20.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 205.14,
    y: 49.16,
    width: 89.56,
    height: 107.94,
    rx: 8.31,
    ry: 8.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 206.97,
    y: 173.34,
    width: 85.93,
    height: 8.84,
    rx: 4.32,
    ry: 4.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 315.23,
    y: 31.34,
    width: 7.37,
    height: 150.65,
    rx: 3.69,
    ry: 3.69
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.34 173.64 215.31 175.1 219.77 175.1 218.74 173.64 216.34 173.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.09 173.64 280.06 175.1 284.52 175.1 283.49 173.64 281.09 173.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 216.76,
    y: 33.53,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 235.26,
    y: 33.53,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 253.76,
    y: 33.53,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 272.26,
    y: 33.53,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M249.05,80.92c.29,.02,.57,.05,.86,.07,2.94,.21,5.75,.91,8.41,2.21,2.02,.99,3.81,2.3,5.26,4.03,.65,.77,1.17,1.63,1.64,2.52,.06,.1,.17,.21,.29,.24,1.03,.28,1.81,.91,2.41,1.77,.8,1.14,1.56,2.31,2.32,3.48,1.01,1.54,2,3.09,3,4.64,.13,.2,.12,.32-.03,.42-.14,.1-.29,.07-.42-.1-.09-.12-.17-.25-.26-.37-1.52-2.33-3.03-4.67-4.56-7-.32-.48-.68-.93-1.05-1.38-.35-.43-.87-.63-1.35-.87-.04-.02-.09-.02-.14-.02-.8,0-1.6,0-2.4,0-.03,0-.06,0-.09,0q-.35,.01-.43,.35c-.05,.21-.08,.41-.14,.62-.05,.19,0,.3,.18,.4,1.08,.6,2.15,1.2,3.22,1.81,.08,.04,.16,.09,.25,.14l-.25,.48c-.14-.08-.27-.14-.39-.21-2.03-1.12-4.05-2.24-6.08-3.36-.08-.04-.16-.08-.24-.13-.57-.29-1.34,.01-1.55,.62-.1,.29-.03,.57,.18,.79,.24,.25,.48,.5,.75,.73,1.57,1.32,3.15,2.63,4.73,3.94,.24,.2,.46,.41,.69,.61,.45,.38,.7,.89,.95,1.41,.15,.32,.28,.65,.42,.98,.52,1.24,1.47,1.96,2.76,2.26,.12,.03,.23,.06,.38,.09-.03,.16-.05,.32-.09,.47,0,.03-.1,.06-.14,.05-.22-.05-.44-.12-.66-.18-1.17-.36-2.05-1.07-2.64-2.13-.06-.11-.12-.14-.24-.09-.26,.1-.53,.2-.8,.29-.39,.13-.7,.37-.98,.65-1.63,1.63-3.54,2.84-5.66,3.72-1.7,.7-3.46,1.18-5.27,1.46-.75,.11-1.52,.16-2.28,.23-.05,0-.09,.02-.14,.03h-3.29s-.08-.02-.12-.03c-.69-.09-1.37-.15-2.06-.26-2.33-.38-4.55-1.08-6.65-2.18-2.09-1.1-3.91-2.52-5.31-4.43-.99-1.34-1.63-2.84-1.91-4.48-.05-.27-.07-.55-.1-.82v-1.23c.01-.08,.02-.16,.03-.25,.03-.26,.05-.53,.1-.79,.33-1.72,1.07-3.25,2.14-4.62,1.33-1.7,3-2.98,4.88-3.99,2.83-1.52,5.86-2.3,9.05-2.53,.29-.02,.59-.05,.88-.07,.64,0,1.28,0,1.91,0Zm15.41,9c-.18-.33-.33-.62-.51-.91-1.11-1.79-2.62-3.17-4.39-4.26-2.78-1.71-5.82-2.66-9.06-2.95-2.4-.22-4.81-.15-7.19,.34-2.55,.53-4.95,1.42-7.13,2.86-1.72,1.14-3.16,2.55-4.2,4.35-1.03,1.8-1.37,3.74-1.09,5.78,.18,1.31,.7,2.51,1.42,3.61,1.18,1.8,2.75,3.17,4.59,4.26,2.92,1.74,6.12,2.58,9.47,2.81,1.39,.09,2.79,.01,4.18-.08,1.47-.1,2.91-.41,4.33-.84,2.31-.7,4.44-1.74,6.31-3.28,.38-.31,.73-.65,1.11-1-.57-.27-1.11-.52-1.64-.79-.28-.14-.56-.3-.83-.46-.41-.26-.67-.98-.3-1.52,.09-.12,.18-.24,.28-.35,.06-.07,.13-.14,.19-.21-.32-.26-.64-.49-.93-.74-.48-.42-.55-1.02-.2-1.56,.05-.08,.1-.15,.17-.25-.26-.05-.5-.09-.73-.13-1.05-.19-2.09-.38-3.14-.58-.46-.09-.75-.55-.67-1,.15-.79,.29-1.57,.45-2.35,.18-.85,.37-1.69,.57-2.53,.11-.46,.61-.78,1.06-.7,1.72,.29,3.45,.59,5.17,.89,.21,.04,.42,.08,.6,.18,.37,.19,.5,.6,.42,1.1-.02,.13-.05,.25-.08,.41l1.74-.1Zm-2.68,1.57s.03-.03,.03-.05c.13-.7,.27-1.39,.39-2.09,.05-.33-.02-.4-.35-.46-1.13-.2-2.26-.41-3.39-.61-.63-.11-1.27-.2-1.91-.28-.33-.04-.4,.02-.47,.33-.33,1.51-.66,3.03-.98,4.55-.09,.41-.03,.51,.38,.59,.93,.19,1.86,.36,2.8,.54,.25,.05,.5,.08,.75,.12l.02-.04c-.11-.09-.21-.19-.32-.28-.46-.4-.94-.78-1.36-1.21-.95-.98-.29-2.29,.79-2.59,.4-.11,.78-.09,1.15,.12,.22,.13,.46,.24,.68,.37,.59,.33,1.18,.66,1.78,1Zm1,6.74c.22-.04,.44-.07,.66-.11,.09-.02,.18-.08,.27-.12-.06-.07-.11-.16-.18-.22-.94-.79-1.89-1.58-2.84-2.37-.17-.14-.35-.28-.53-.41-.23-.16-.42-.12-.64,.11-.33,.34-.38,.54-.2,.78,.07,.1,.16,.2,.25,.28,.29,.25,.59,.5,.9,.73,.5,.37,1,.73,1.51,1.08,.24,.16,.51,.25,.8,.26Zm.05,1.91c.05,0,.08,0,.1-.01,.47-.15,.95-.3,1.42-.47,.03-.01,.07-.11,.05-.15-.06-.19-.13-.39-.21-.58-.12-.29-.2-.33-.52-.27-.26,.04-.52,.1-.78,.12-.59,.06-1.09-.19-1.56-.51-.24-.16-.48-.32-.72-.48-.06-.03-.15-.06-.2-.04-.27,.13-.43,.34-.46,.64-.03,.26,.08,.46,.32,.57,.77,.37,1.55,.74,2.32,1.1,.08,.04,.17,.05,.23,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M253.16,93.27c.05,3.2-.63,5.78-1.91,8.22-.11,.21-.24,.4-.37,.6-.2,.3-.49,.35-.81,.29-.5-.09-.83-.69-.63-1.15,.24-.54,.52-1.07,.76-1.61,.96-2.19,1.27-4.48,1.14-6.85-.11-2-.66-3.86-1.54-5.65-.13-.26-.25-.53-.37-.8-.18-.42,.1-.96,.54-1.08,.33-.08,.77-.04,1.03,.39,.69,1.16,1.18,2.4,1.55,3.7,.41,1.44,.61,2.9,.6,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M249.47,93.57c0,2.16-.48,4.21-1.47,6.13-.12,.24-.28,.46-.46,.67-.23,.27-.54,.39-.89,.25-.35-.14-.55-.41-.59-.78-.01-.12,.03-.26,.08-.38,.25-.58,.54-1.15,.78-1.74,.67-1.69,.88-3.44,.66-5.26-.16-1.33-.56-2.56-1.15-3.75-.11-.23-.2-.46-.31-.69-.24-.54,.22-1.07,.72-1.1,.37-.02,.65,.09,.85,.43,.86,1.5,1.45,3.09,1.65,4.81,.06,.47,.09,.95,.13,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M245.71,94.05c.05,1.37-.41,2.85-1.2,4.25-.08,.15-.18,.29-.29,.41-.25,.26-.56,.31-.88,.18-.34-.13-.55-.39-.59-.76-.01-.14,.06-.3,.12-.44,.2-.47,.43-.93,.61-1.4,.73-1.95,.59-3.85-.29-5.72-.13-.28-.27-.55-.38-.84-.16-.43-.04-.74,.38-1.01,.26-.17,.75-.12,.99,.12,.13,.13,.24,.28,.34,.44,.81,1.38,1.18,2.83,1.18,4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M240.41,93.61c.03-.52-.12-1.15-.5-1.73-.09-.13-.16-.28-.23-.43-.18-.38-.05-.8,.32-1.06,.35-.24,.76-.22,1.05,.09,.47,.5,.77,1.11,.95,1.76,.44,1.53,.27,2.99-.57,4.35-.12,.2-.29,.39-.47,.54-.3,.26-.68,.26-.97,.04-.35-.26-.49-.66-.34-1.03,.06-.16,.14-.3,.23-.45,.44-.75,.52-1.05,.53-2.08Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 174.54,
    y: 51.31,
    width: 64.4,
    height: 109.09,
    rx: 9.35,
    ry: 9.35,
    transform: "translate(201.74 338.08) rotate(-115.88)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 184.56,
    cy: 128.48,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 189.78,
    cy: 125.95,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 195,
    cy: 123.42,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 200.22,
    cy: 120.89,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 205.44,
    cy: 118.36,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 210.66,
    cy: 115.82,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 215.87,
    cy: 113.29,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 221.09,
    cy: 110.76,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 226.31,
    cy: 108.23,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 231.53,
    cy: 105.7,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 236.75,
    cy: 103.16,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 241.97,
    cy: 100.63,
    r: 1.1
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 227.03,
    y: 75.09,
    width: 11.55,
    height: 17.97,
    transform: "translate(206.84 -162.09) rotate(64.12)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M311.79,59.53c4.84,15.04,3.88,29.4-2.94,43.34-.84,1.71-2.25,2.29-3.7,1.56-1.37-.69-1.69-2.06-.85-3.8,4.94-10.13,6.62-20.78,4.55-31.86-2.65-14.17-10.17-25.22-22.15-33.22-1.87-1.25-3.9-2.26-5.87-3.34-1.6-.87-2.18-2.14-1.54-3.49,.68-1.41,2.17-1.86,3.77-1.07,12.5,6.14,21.69,15.47,27.24,28.3,.55,1.27,1.06,2.56,1.48,3.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M297.29,65.37c3.26,10.07,2.62,20.48-2.28,30.6-.87,1.8-2.3,2.4-3.77,1.63-1.31-.68-1.66-1.99-.9-3.56,2.51-5.24,3.97-10.74,3.74-16.57-.53-13.91-7.03-24.16-19.16-30.9-.45-.25-.94-.45-1.38-.72-1.28-.78-1.68-1.97-1.11-3.21,.59-1.28,2.07-1.97,3.38-1.27,2.51,1.35,5.05,2.71,7.34,4.4,6.6,4.86,11.16,11.29,14.13,19.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M282.36,69.86c2.17,6.6,1.82,13.06-1.23,19.32-.36,.74-1.12,1.46-1.87,1.8-.96,.43-1.96,.04-2.66-.82-.72-.88-.65-1.84-.17-2.8,1.43-2.88,2.24-5.93,2.17-9.15-.17-8.05-3.85-14.03-10.84-18-.19-.11-.39-.19-.58-.29-1.47-.79-2.01-2.15-1.38-3.44,.66-1.35,2.15-1.81,3.68-1.08,3.09,1.48,5.77,3.51,8.02,6.09,2.17,2.47,3.81,5.25,4.87,8.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M267.65,74.99c.89,2.59,.72,5.11-.46,7.57-.76,1.57-2.1,2.15-3.49,1.55-1.42-.62-1.83-1.91-1.14-3.6,1.15-2.81,.34-5.19-2.29-6.76-1.49-.89-1.97-2.17-1.3-3.46,.7-1.33,2.19-1.75,3.69-1,2.44,1.22,4.1,3.13,4.99,5.7Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 491.01,
    y: 27.99,
    width: 7.37,
    height: 150.65,
    rx: 3.69,
    ry: 3.69
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M484.71,44.17c11.75-2.33,23.52-4.62,35.29-6.88,4.81-.92,8.9,3.64,9.05,10.14,.77,32.94,1.55,65.89,2.31,98.83,.15,6.51-3.68,10.53-8.52,8.92-12.06-4-24.13-7.99-36.19-11.99-4.84-1.6-8.86-7.01-8.94-12.02-.4-25.4-.81-50.81-1.22-76.21-.08-5.02,3.61-9.88,8.23-10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M488.25,44.39c4.31-.83,6.48-1.25,10.83-2.08,.95,35.13,2.61,70.21,2.51,105.36-4.5-1.48-6.76-2.22-11.26-3.7-.14-33.21-1.36-66.38-2.08-99.58Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.42,125.37c.49,.1,.9,.7,.92,1.33,.01,.63-.38,1.05-.88,.94s-.9-.71-.91-1.33c-.01-.62,.38-1.05,.88-.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.31,119.36c.49,.09,.91,.67,.92,1.3,.01,.63-.38,1.06-.87,.97-.49-.1-.91-.68-.92-1.3-.01-.62,.38-1.06,.87-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.18,113.34c.49,.08,.91,.65,.92,1.28s-.38,1.07-.87,.99c-.49-.08-.91-.65-.92-1.28s.38-1.07,.87-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M513.04,107.33c.49,.06,.91,.62,.92,1.25,.02,.63-.37,1.09-.87,1.02-.49-.07-.91-.63-.92-1.25-.02-.62,.37-1.08,.87-1.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512.88,101.31c.5,.05,.91,.6,.93,1.23,.02,.63-.37,1.1-.87,1.04-.49-.05-.91-.6-.93-1.23s.37-1.09,.86-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512.69,95.3c.5,.03,.91,.57,.93,1.2,.02,.63-.36,1.11-.86,1.07-.5-.04-.91-.58-.93-1.2-.02-.62,.36-1.1,.86-1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512.49,89.29c.5,.02,.91,.55,.94,1.18,.02,.63-.36,1.12-.86,1.09-.5-.03-.91-.55-.94-1.18-.02-.62,.36-1.11,.86-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512.28,83.28c.5,0,.92,.52,.94,1.15,.02,.63-.36,1.13-.86,1.12-.5-.01-.92-.53-.94-1.15-.02-.62,.36-1.13,.86-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M512.07,77.26c.5,0,.92,.5,.94,1.13s-.36,1.14-.86,1.14-.92-.5-.94-1.13c-.02-.62,.36-1.14,.86-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M511.86,71.25c.5-.02,.92,.47,.94,1.1,.02,.63-.36,1.15-.86,1.17-.5,.02-.92-.48-.94-1.1-.02-.62,.36-1.15,.86-1.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M511.65,65.24c.5-.04,.92,.45,.94,1.08s-.36,1.16-.86,1.19c-.5,.03-.92-.45-.94-1.08-.02-.62,.36-1.16,.86-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M511.45,59.23c.5-.05,.92,.42,.94,1.05,.02,.63-.37,1.18-.86,1.22-.5,.04-.92-.43-.94-1.05-.02-.62,.37-1.17,.86-1.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M512.39,46.02c-.3-15.34-.49-30.67-.52-46.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M508.8,46.59c-.24-9.34-.35-14.01-.48-23.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M505.31,47.15c-.33-11.84-.55-23.68-.56-35.53"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 453.07,
    y: 27.99,
    width: 38.24,
    height: 150.65,
    rx: 5.71,
    ry: 5.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 358.31,
    y: 27.73,
    width: 126.8,
    height: 151.17,
    rx: 24.68,
    ry: 24.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 361.34,
    y: 30.84,
    width: 120.71,
    height: 137.84,
    rx: 20.65,
    ry: 20.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 376.92,
    y: 45.8,
    width: 89.56,
    height: 107.94,
    rx: 8.31,
    ry: 8.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 378.75,
    y: 169.99,
    width: 85.93,
    height: 8.84,
    rx: 4.32,
    ry: 4.32
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.12 170.29 387.08 171.74 391.55 171.74 390.51 170.29 388.12 170.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.87 170.29 451.83 171.74 456.3 171.74 455.26 170.29 452.87 170.29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 388.54,
    y: 30.17,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 407.04,
    y: 30.17,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 425.54,
    y: 30.17,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 444.04,
    y: 30.17,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M420.83,82.57c.29,.02,.57,.05,.86,.07,2.94,.21,5.75,.91,8.41,2.21,2.02,.99,3.81,2.3,5.26,4.03,.65,.77,1.17,1.63,1.64,2.52,.06,.1,.17,.21,.29,.24,1.03,.28,1.81,.91,2.41,1.77,.8,1.14,1.56,2.31,2.32,3.48,1.01,1.54,2,3.09,3,4.64,.13,.2,.12,.32-.03,.42-.14,.1-.29,.07-.42-.1-.09-.12-.17-.25-.26-.37-1.52-2.33-3.03-4.67-4.56-7-.32-.48-.68-.93-1.05-1.38-.35-.43-.87-.63-1.35-.87-.04-.02-.09-.02-.14-.02-.8,0-1.6,0-2.4,0-.03,0-.06,0-.09,0q-.35,.01-.43,.35c-.05,.21-.08,.41-.14,.62-.05,.19,0,.3,.18,.4,1.08,.6,2.15,1.2,3.22,1.81,.08,.04,.16,.09,.25,.14l-.25,.48c-.14-.08-.27-.14-.39-.21-2.03-1.12-4.05-2.24-6.08-3.36-.08-.04-.16-.08-.24-.13-.57-.29-1.34,.01-1.55,.62-.1,.29-.03,.57,.18,.79,.24,.25,.48,.5,.75,.73,1.57,1.32,3.15,2.63,4.73,3.94,.24,.2,.46,.41,.69,.61,.45,.38,.7,.89,.95,1.41,.15,.32,.28,.65,.42,.98,.52,1.24,1.47,1.96,2.76,2.26,.12,.03,.23,.06,.38,.09-.03,.16-.05,.32-.09,.47,0,.03-.1,.06-.14,.05-.22-.05-.44-.12-.66-.18-1.17-.36-2.05-1.07-2.64-2.13-.06-.11-.12-.14-.24-.09-.26,.1-.53,.2-.8,.29-.39,.13-.7,.37-.98,.65-1.63,1.63-3.54,2.84-5.66,3.72-1.7,.7-3.46,1.18-5.27,1.46-.75,.11-1.52,.16-2.28,.23-.05,0-.09,.02-.14,.03h-3.29s-.08-.02-.12-.03c-.69-.09-1.37-.15-2.06-.26-2.33-.38-4.55-1.08-6.65-2.18-2.09-1.1-3.91-2.52-5.31-4.43-.99-1.34-1.63-2.84-1.91-4.48-.05-.27-.07-.55-.1-.82v-1.23c.01-.08,.02-.16,.03-.25,.03-.26,.05-.53,.1-.79,.33-1.72,1.07-3.25,2.14-4.62,1.33-1.7,3-2.98,4.88-3.99,2.83-1.52,5.86-2.3,9.05-2.53,.29-.02,.59-.05,.88-.07,.64,0,1.28,0,1.91,0Zm15.41,9c-.18-.33-.33-.62-.51-.91-1.11-1.79-2.62-3.17-4.39-4.26-2.78-1.71-5.82-2.66-9.06-2.95-2.4-.22-4.81-.15-7.19,.34-2.55,.53-4.95,1.42-7.13,2.86-1.72,1.14-3.16,2.55-4.2,4.35-1.03,1.8-1.37,3.74-1.09,5.78,.18,1.31,.7,2.51,1.42,3.61,1.18,1.8,2.75,3.17,4.59,4.26,2.92,1.74,6.12,2.58,9.47,2.81,1.39,.09,2.79,.01,4.18-.08,1.47-.1,2.91-.41,4.33-.84,2.31-.7,4.44-1.74,6.31-3.28,.38-.31,.73-.65,1.11-1-.57-.27-1.11-.52-1.64-.79-.28-.14-.56-.3-.83-.46-.41-.26-.67-.98-.3-1.52,.09-.12,.18-.24,.28-.35,.06-.07,.13-.14,.19-.21-.32-.26-.64-.49-.93-.74-.48-.42-.55-1.02-.2-1.56,.05-.08,.1-.15,.17-.25-.26-.05-.5-.09-.73-.13-1.05-.19-2.09-.38-3.14-.58-.46-.09-.75-.55-.67-1,.15-.79,.29-1.57,.45-2.35,.18-.85,.37-1.69,.57-2.53,.11-.46,.61-.78,1.06-.7,1.72,.29,3.45,.59,5.17,.89,.21,.04,.42,.08,.6,.18,.37,.19,.5,.6,.42,1.1-.02,.13-.05,.25-.08,.41l1.74-.1Zm-2.68,1.57s.03-.03,.03-.05c.13-.7,.27-1.39,.39-2.09,.05-.33-.02-.4-.35-.46-1.13-.2-2.26-.41-3.39-.61-.63-.11-1.27-.2-1.91-.28-.33-.04-.4,.02-.47,.33-.33,1.51-.66,3.03-.98,4.55-.09,.41-.03,.51,.38,.59,.93,.19,1.86,.36,2.8,.54,.25,.05,.5,.08,.75,.12l.02-.04c-.11-.09-.21-.19-.32-.28-.46-.4-.94-.78-1.36-1.21-.95-.98-.29-2.29,.79-2.59,.4-.11,.78-.09,1.15,.12,.22,.13,.46,.24,.68,.37,.59,.33,1.18,.66,1.78,1Zm1,6.74c.22-.04,.44-.07,.66-.11,.09-.02,.18-.08,.27-.12-.06-.07-.11-.16-.18-.22-.94-.79-1.89-1.58-2.84-2.37-.17-.14-.35-.28-.53-.41-.23-.16-.42-.12-.64,.11-.33,.34-.38,.54-.2,.78,.07,.1,.16,.2,.25,.28,.29,.25,.59,.5,.9,.73,.5,.37,1,.73,1.51,1.08,.24,.16,.51,.25,.8,.26Zm.05,1.91c.05,0,.08,0,.1-.01,.47-.15,.95-.3,1.42-.47,.03-.01,.07-.11,.05-.15-.06-.19-.13-.39-.21-.58-.12-.29-.2-.33-.52-.27-.26,.04-.52,.1-.78,.12-.59,.06-1.09-.19-1.56-.51-.24-.16-.48-.32-.72-.48-.06-.03-.15-.06-.2-.04-.27,.13-.43,.34-.46,.64-.03,.26,.08,.46,.32,.57,.77,.37,1.55,.74,2.32,1.1,.08,.04,.17,.05,.23,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M424.93,94.92c.05,3.2-.63,5.78-1.91,8.22-.11,.21-.24,.4-.37,.6-.2,.3-.49,.35-.81,.29-.5-.09-.83-.69-.63-1.15,.24-.54,.52-1.07,.76-1.61,.96-2.19,1.27-4.48,1.14-6.85-.11-2-.66-3.86-1.54-5.65-.13-.26-.25-.53-.37-.8-.18-.42,.1-.96,.54-1.08,.33-.08,.77-.04,1.03,.39,.69,1.16,1.18,2.4,1.55,3.7,.41,1.44,.61,2.9,.6,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M421.25,95.21c0,2.16-.48,4.21-1.47,6.13-.12,.24-.28,.46-.46,.67-.23,.27-.54,.39-.89,.25-.35-.14-.55-.41-.59-.78-.01-.12,.03-.26,.08-.38,.25-.58,.54-1.15,.78-1.74,.67-1.69,.88-3.44,.66-5.26-.16-1.33-.56-2.56-1.15-3.75-.11-.23-.2-.46-.31-.69-.24-.54,.22-1.07,.72-1.1,.37-.02,.65,.09,.85,.43,.86,1.5,1.45,3.09,1.65,4.81,.06,.47,.09,.95,.13,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M417.48,95.7c.05,1.37-.41,2.85-1.2,4.25-.08,.15-.18,.29-.29,.41-.25,.26-.56,.31-.88,.18-.34-.13-.55-.39-.59-.76-.01-.14,.06-.3,.12-.44,.2-.47,.43-.93,.61-1.4,.73-1.95,.59-3.85-.29-5.72-.13-.28-.27-.55-.38-.84-.16-.43-.04-.74,.38-1.01,.26-.17,.75-.12,.99,.12,.13,.13,.24,.28,.34,.44,.81,1.38,1.18,2.83,1.18,4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M412.18,95.26c.03-.52-.12-1.15-.5-1.73-.09-.13-.16-.28-.23-.43-.18-.38-.05-.8,.32-1.06,.35-.24,.76-.22,1.05,.09,.47,.5,.77,1.11,.95,1.76,.44,1.53,.27,2.99-.57,4.35-.12,.2-.29,.39-.47,.54-.3,.26-.68,.26-.97,.04-.35-.26-.49-.66-.34-1.03,.06-.16,.14-.3,.23-.45,.44-.75,.52-1.05,.53-2.08Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 132.69,
    y: 32.9,
    width: 7.37,
    height: 150.65,
    rx: 3.69,
    ry: 3.69
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 94.76,
    y: 32.9,
    width: 38.24,
    height: 150.65,
    rx: 5.71,
    ry: 5.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    y: 32.64,
    width: 126.8,
    height: 151.17,
    rx: 24.68,
    ry: 24.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 20.44,
    y: 174.9,
    width: 85.93,
    height: 8.84,
    rx: 4.32,
    ry: 4.32
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.81 175.2 28.77 176.66 33.24 176.66 32.2 175.2 29.81 175.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.56 175.2 93.52 176.66 97.99 176.66 96.95 175.2 94.56 175.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 33.92,
    y: 145.98,
    width: 64.4,
    height: 109.09,
    rx: 9.35,
    ry: 9.35,
    transform: "translate(132.35 401.03) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.81,
    cy: 230.36,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.81,
    cy: 224.56,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.8,
    cy: 218.76,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.8,
    cy: 212.96,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.8,
    cy: 207.15,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.79,
    cy: 201.35,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.79,
    cy: 195.55,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.79,
    cy: 189.75,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.79,
    cy: 183.95,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.78,
    cy: 178.15,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.78,
    cy: 172.35,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 76.78,
    cy: 166.55,
    r: 1.1
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 52.11,
    y: 158.59,
    width: 11.55,
    height: 17.97
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 62.47,
    y1: 242.14,
    x2: 62.29,
    y2: 286.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 66.82,
    y1: 242.14,
    x2: 66.82,
    y2: 264.92
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 71.08,
    y1: 242.14,
    x2: 71.08,
    y2: 277.36
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 3.03,
    y: 35.76,
    width: 120.71,
    height: 137.84,
    rx: 20.65,
    ry: 20.65
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.61,
    y: 50.72,
    width: 89.56,
    height: 107.94,
    rx: 8.31,
    ry: 8.31
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 30.22,
    y: 35.09,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 48.72,
    y: 35.09,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 67.22,
    y: 35.09,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 85.72,
    y: 35.09,
    width: 9.13,
    height: 10.39
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M62.52,87.48c.29,.02,.57,.05,.86,.07,2.94,.21,5.75,.91,8.41,2.21,2.02,.99,3.81,2.3,5.26,4.03,.65,.77,1.17,1.63,1.64,2.52,.06,.1,.17,.21,.29,.24,1.03,.28,1.81,.91,2.41,1.77,.8,1.14,1.56,2.31,2.32,3.48,1.01,1.54,2,3.09,3,4.64,.13,.2,.12,.32-.03,.42-.14,.1-.29,.07-.42-.1-.09-.12-.17-.25-.26-.37-1.52-2.33-3.03-4.67-4.56-7-.32-.48-.68-.93-1.05-1.38-.35-.43-.87-.63-1.35-.87-.04-.02-.09-.02-.14-.02-.8,0-1.6,0-2.4,0-.03,0-.06,0-.09,0q-.35,.01-.43,.35c-.05,.21-.08,.41-.14,.62-.05,.19,0,.3,.18,.4,1.08,.6,2.15,1.2,3.22,1.81,.08,.04,.16,.09,.25,.14l-.25,.48c-.14-.08-.27-.14-.39-.21-2.03-1.12-4.05-2.24-6.08-3.36-.08-.04-.16-.08-.24-.13-.57-.29-1.34,.01-1.55,.62-.1,.29-.03,.57,.18,.79,.24,.25,.48,.5,.75,.73,1.57,1.32,3.15,2.63,4.73,3.94,.24,.2,.46,.41,.69,.61,.45,.38,.7,.89,.95,1.41,.15,.32,.28,.65,.42,.98,.52,1.24,1.47,1.96,2.76,2.26,.12,.03,.23,.06,.38,.09-.03,.16-.05,.32-.09,.47,0,.03-.1,.06-.14,.05-.22-.05-.44-.12-.66-.18-1.17-.36-2.05-1.07-2.64-2.13-.06-.11-.12-.14-.24-.09-.26,.1-.53,.2-.8,.29-.39,.13-.7,.37-.98,.65-1.63,1.63-3.54,2.84-5.66,3.72-1.7,.7-3.46,1.18-5.27,1.46-.75,.11-1.52,.16-2.28,.23-.05,0-.09,.02-.14,.03h-3.29s-.08-.02-.12-.03c-.69-.09-1.37-.15-2.06-.26-2.33-.38-4.55-1.08-6.65-2.18-2.09-1.1-3.91-2.52-5.31-4.43-.99-1.34-1.63-2.84-1.91-4.48-.05-.27-.07-.55-.1-.82v-1.23c.01-.08,.02-.16,.03-.25,.03-.26,.05-.53,.1-.79,.33-1.72,1.07-3.25,2.14-4.62,1.33-1.7,3-2.98,4.88-3.99,2.83-1.52,5.86-2.3,9.05-2.53,.29-.02,.59-.05,.88-.07,.64,0,1.28,0,1.91,0Zm15.41,9c-.18-.33-.33-.62-.51-.91-1.11-1.79-2.62-3.17-4.39-4.26-2.78-1.71-5.82-2.66-9.06-2.95-2.4-.22-4.81-.15-7.19,.34-2.55,.53-4.95,1.42-7.13,2.86-1.72,1.14-3.16,2.55-4.2,4.35-1.03,1.8-1.37,3.74-1.09,5.78,.18,1.31,.7,2.51,1.42,3.61,1.18,1.8,2.75,3.17,4.59,4.26,2.92,1.74,6.12,2.58,9.47,2.81,1.39,.09,2.79,.01,4.18-.08,1.47-.1,2.91-.41,4.33-.84,2.31-.7,4.44-1.74,6.31-3.28,.38-.31,.73-.65,1.11-1-.57-.27-1.11-.52-1.64-.79-.28-.14-.56-.3-.83-.46-.41-.26-.67-.98-.3-1.52,.09-.12,.18-.24,.28-.35,.06-.07,.13-.14,.19-.21-.32-.26-.64-.49-.93-.74-.48-.42-.55-1.02-.2-1.56,.05-.08,.1-.15,.17-.25-.26-.05-.5-.09-.73-.13-1.05-.19-2.09-.38-3.14-.58-.46-.09-.75-.55-.67-1,.15-.79,.29-1.57,.45-2.35,.18-.85,.37-1.69,.57-2.53,.11-.46,.61-.78,1.06-.7,1.72,.29,3.45,.59,5.17,.89,.21,.04,.42,.08,.6,.18,.37,.19,.5,.6,.42,1.1-.02,.13-.05,.25-.08,.41l1.74-.1Zm-2.68,1.57s.03-.03,.03-.05c.13-.7,.27-1.39,.39-2.09,.05-.33-.02-.4-.35-.46-1.13-.2-2.26-.41-3.39-.61-.63-.11-1.27-.2-1.91-.28-.33-.04-.4,.02-.47,.33-.33,1.51-.66,3.03-.98,4.55-.09,.41-.03,.51,.38,.59,.93,.19,1.86,.36,2.8,.54,.25,.05,.5,.08,.75,.12l.02-.04c-.11-.09-.21-.19-.32-.28-.46-.4-.94-.78-1.36-1.21-.95-.98-.29-2.29,.79-2.59,.4-.11,.78-.09,1.15,.12,.22,.13,.46,.24,.68,.37,.59,.33,1.18,.66,1.78,1Zm1,6.74c.22-.04,.44-.07,.66-.11,.09-.02,.18-.08,.27-.12-.06-.07-.11-.16-.18-.22-.94-.79-1.89-1.58-2.84-2.37-.17-.14-.35-.28-.53-.41-.23-.16-.42-.12-.64,.11-.33,.34-.38,.54-.2,.78,.07,.1,.16,.2,.25,.28,.29,.25,.59,.5,.9,.73,.5,.37,1,.73,1.51,1.08,.24,.16,.51,.25,.8,.26Zm.05,1.91c.05,0,.08,0,.1-.01,.47-.15,.95-.3,1.42-.47,.03-.01,.07-.11,.05-.15-.06-.19-.13-.39-.21-.58-.12-.29-.2-.33-.52-.27-.26,.04-.52,.1-.78,.12-.59,.06-1.09-.19-1.56-.51-.24-.16-.48-.32-.72-.48-.06-.03-.15-.06-.2-.04-.27,.13-.43,.34-.46,.64-.03,.26,.08,.46,.32,.57,.77,.37,1.55,.74,2.32,1.1,.08,.04,.17,.05,.23,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M66.62,99.83c.05,3.2-.63,5.78-1.91,8.22-.11,.21-.24,.4-.37,.6-.2,.3-.49,.35-.81,.29-.5-.09-.83-.69-.63-1.15,.24-.54,.52-1.07,.76-1.61,.96-2.19,1.27-4.48,1.14-6.85-.11-2-.66-3.86-1.54-5.65-.13-.26-.25-.53-.37-.8-.18-.42,.1-.96,.54-1.08,.33-.08,.77-.04,1.03,.39,.69,1.16,1.18,2.4,1.55,3.7,.41,1.44,.61,2.9,.6,3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M62.93,100.13c0,2.16-.48,4.21-1.47,6.13-.12,.24-.28,.46-.46,.67-.23,.27-.54,.39-.89,.25-.35-.14-.55-.41-.59-.78-.01-.12,.03-.26,.08-.38,.25-.58,.54-1.15,.78-1.74,.67-1.69,.88-3.44,.66-5.26-.16-1.33-.56-2.56-1.15-3.75-.11-.23-.2-.46-.31-.69-.24-.54,.22-1.07,.72-1.1,.37-.02,.65,.09,.85,.43,.86,1.5,1.45,3.09,1.65,4.81,.06,.47,.09,.95,.13,1.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M59.17,100.61c.05,1.37-.41,2.85-1.2,4.25-.08,.15-.18,.29-.29,.41-.25,.26-.56,.31-.88,.18-.34-.13-.55-.39-.59-.76-.01-.14,.06-.3,.12-.44,.2-.47,.43-.93,.61-1.4,.73-1.95,.59-3.85-.29-5.72-.13-.28-.27-.55-.38-.84-.16-.43-.04-.74,.38-1.01,.26-.17,.75-.12,.99,.12,.13,.13,.24,.28,.34,.44,.81,1.38,1.18,2.83,1.18,4.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M53.87,100.17c.03-.52-.12-1.15-.5-1.73-.09-.13-.16-.28-.23-.43-.18-.38-.05-.8,.32-1.06,.35-.24,.76-.22,1.05,.09,.47,.5,.77,1.11,.95,1.76,.44,1.53,.27,2.99-.57,4.35-.12,.2-.29,.39-.47,.54-.3,.26-.68,.26-.97,.04-.35-.26-.49-.66-.34-1.03,.06-.16,.14-.3,.23-.45,.44-.75,.52-1.05,.53-2.08Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentTerminal);
export default __webpack_public_path__ + "static/media/paymentTerminal.bf9b563f47336b2969584eb0de4ec338.svg";
export { ForwardRef as ReactComponent };